export default __webpack_public_path__ + "static/media/whiteTruckRightTablet.768dea5f.jpg";